import {
    CREATING_DASHBOARD,
    CREATING_DASHBOARD_FAILURE,
    CREATING_DASHBOARD_SUCCESS,
    RESET_CREATING_DASHBOARD_SUCCESS,
    GETTING_DASHBOARDS_BY_SITE,
    GETTING_DASHBOARDS_BY_SITE_SUCCESS,
    GETTING_DASHBOARDS_BY_SITE_FAILURE,
    RESET_GETTING_DASHBOARDS_BY_SITE,
    DELETING_DASHBOARD,
    DELETING_DASHBOARD_SUCCESS,
    DELETING_DASHBOARD_FAILURE,
    RESET_DELETING_DASHBOARD,
    UPDATING_DASHBOARD,
    UPDATING_DASHBOARD_FAILURE,
    UPDATING_DASHBOARD_SUCCESS,
    RESET_UPDATING_DASHBOARD,
    UPDATING_DASHBOARDS,
    UPDATING_DASHBOARDS_FAILURE,
    UPDATING_DASHBOARDS_SUCCESS,
    RESET_UPDATING_DASHBOARDS,
    UPDATING_DASHBOARD_LINKS,
    UPDATING_DASHBOARD_LINKS_FAILURE,
    UPDATING_DASHBOARD_LINKS_SUCCESS,
    RESET_UPDATING_DASHBOARD_LINKS,
    ADDING_INFO_ITEM,
    ADDING_INFO_ITEM_SUCCESS,
    ADDING_INFO_ITEM_FAILURE,
    RESET_ADDING_INFO_ITEM,
    UPDATING_INFO_ITEM,
    UPDATING_INFO_ITEM_SUCCESS,
    UPDATING_INFO_ITEM_FAILURE,
    RESET_UPDATING_INFO_ITEM,
    GETTING_DASHBOARD,
    GETTING_DASHBOARD_SUCCESS,
    GETTING_DASHBOARD_FAILURE,
    RESET_GETTING_DASHBOARD,
    DELETING_INFO_ITEM,
    DELETING_INFO_ITEM_SUCCESS,
    DELETING_INFO_ITEM_FAILURE,
    RESET_DELETING_INFO_ITEM,
    ADDING_LINK,
    ADDING_LINK_SUCCESS,
    ADDING_LINK_FAILURE,
    RESET_ADDING_LINK,
    GETTING_LINK,
    GETTING_LINK_SUCCESS,
    GETTING_LINK_FAILURE,
    RESET_GETTING_LINK,
    DELETING_LINK,
    DELETING_LINK_SUCCESS,
    DELETING_LINK_FAILURE,
    RESET_DELETING_LINK,
    EDITING_LINK,
    EDITING_LINK_SUCCESS,
    EDITING_LINK_FAILURE,
    RESET_EDITING_LINK,
    GETTING_URL,
    GETTING_URL_SUCCESS,
    GETTING_URL_FAILURE,
    RESET_GETTING_URL,
    SENDING_LINK_HIT,
    SENDING_LINK_HIT_SUCCESS,
    SENDING_LINK_HIT_FAILURE,
    RESET_SENDING_LINK_HIT,
    DELETING_DASHBOARDS,
    DELETING_DASHBOARDS_SUCCESS,
    DELETING_DASHBOARDS_FAILURE,
    RESET_DELETING_DASHBOARDS,
    DELETING_LINKS,
    DELETING_LINKS_SUCCESS,
    DELETING_LINKS_FAILURE,
    RESET_DELETING_LINKS,
    GETTING_MY_DASHBOARDS,
    GETTING_MY_DASHBOARDS_SUCCESS,
    GETTING_MY_DASHBOARDS_FAILURE,
    RESET_GETTING_MY_DASHBOARDS,
    SENDING_DASHBOARD_HIT,
    SENDING_DASHBOARD_HIT_SUCCESS,
    SENDING_DASHBOARD_HIT_FAILURE,
    UPLOADING_DASHBOARD_PHOTO,
    UPLOADING_DASHBOARD_PHOTO_SUCCESS,
    UPLOADING_DASHBOARD_PHOTO_FAILURE,
    RESET_UPLOADING_DASHBOARD_PHOTO,
    DELETING_DASHBOARD_PHOTO,
    DELETING_DASHBOARD_PHOTO_SUCCESS,
    DELETING_DASHBOARD_PHOTO_FAILURE,
    RESET_DELETING_DASHBOARD_PHOTO,
    TRIGGERED_BULK_UPLOAD
} from 'redux/reduxConstants';

export function creatingDashboard() {
    return { type: CREATING_DASHBOARD };
}

export function creatingDashboardSuccess(newDashboard) {
    return { type: CREATING_DASHBOARD_SUCCESS, newDashboard };
}

export function creatingDashboardFailure(error) {
    return { type: CREATING_DASHBOARD_FAILURE, error };
}

export function resetCreatingDashboardSuccess() {
    return { type: RESET_CREATING_DASHBOARD_SUCCESS };
}

export function gettingDashboard() {
    return { type: GETTING_DASHBOARD };
}

export function gettingDashboardSuccess(dashboard) {
    return { type: GETTING_DASHBOARD_SUCCESS, dashboard };
}

export function gettingDashboardFailure(error) {
    return { type: GETTING_DASHBOARD_FAILURE, error };
}

export function resetGettingDashboard() {
    return { type: RESET_GETTING_DASHBOARD };
}

export function gettingDashboardsBySite() {
    return { type: GETTING_DASHBOARDS_BY_SITE };
}

export function gettingDashboardsBySiteSuccess(dashboards) {
    return { type: GETTING_DASHBOARDS_BY_SITE_SUCCESS, dashboards };
}

export function gettingDashboardsBySiteFailure(error) {
    return { type: GETTING_DASHBOARDS_BY_SITE_FAILURE, error };
}

export function resetGettingDashboardsBySite() {
    return { type: RESET_GETTING_DASHBOARDS_BY_SITE };
}

export function updatingDashboard() {
    return { type: UPDATING_DASHBOARD };
}

export function updatingDashboardSuccess(dashboard) {
    return { type: UPDATING_DASHBOARD_SUCCESS, dashboard };
}

export function updatingDashboardFailure(error) {
    return { type: UPDATING_DASHBOARD_FAILURE, error };
}

export function resetUpdatingDashboard() {
    return { type: RESET_UPDATING_DASHBOARD };
}

export function updatingDashboards(dashboards) {
    return { type: UPDATING_DASHBOARDS, dashboards };
}

export function updatingDashboardsSuccess() {
    return { type: UPDATING_DASHBOARDS_SUCCESS };
}

export function updatingDashboardsFailure(error) {
    return { type: UPDATING_DASHBOARDS_FAILURE, error };
}

export function resetUpdatingDashboards() {
    return { type: RESET_UPDATING_DASHBOARDS };
}

export function deletingDashboard() {
    return { type: DELETING_DASHBOARD };
}

export function deletingDashboardSuccess(dashboard) {
    return { type: DELETING_DASHBOARD_SUCCESS, dashboard };
}

export function deletingDashboardFailure(error) {
    return { type: DELETING_DASHBOARD_FAILURE, error };
}

export function resetDeletingDashboard() {
    return { type: RESET_DELETING_DASHBOARD };
}

export function updatingDashboardLinks(links) {
    return { type: UPDATING_DASHBOARD_LINKS, links };
}

export function updatingDashboardLinksSuccess() {
    return { type: UPDATING_DASHBOARD_LINKS_SUCCESS };
}

export function updatingDashboardLinksFailure(error) {
    return { type: UPDATING_DASHBOARD_LINKS_FAILURE, error };
}

export function resetUpdatingDashboardLinks() {
    return { type: RESET_UPDATING_DASHBOARD_LINKS };
}

export function addingInfoItem() {
    return { type: ADDING_INFO_ITEM };
}

export function addingInfoItemSuccess(newInfoItem) {
    return { type: ADDING_INFO_ITEM_SUCCESS, newInfoItem };
}

export function addingInfoItemFailure(error) {
    return { type: ADDING_INFO_ITEM_FAILURE, error };
}

export function resetAddingInfoItem() {
    return { type: RESET_ADDING_INFO_ITEM };
}

export function updatingInfoItem() {
    return { type: UPDATING_INFO_ITEM };
}

export function udpatingInfoItemSuccess(updatedInfoItem) {
    return { type: UPDATING_INFO_ITEM_SUCCESS, updatedInfoItem };
}

export function updatingInfoItemFailure(error) {
    return { type: UPDATING_INFO_ITEM_FAILURE, error };
}

export function resetUpatingInfoItem() {
    return { type: RESET_UPDATING_INFO_ITEM };
}

export function deletingInfoItem() {
    return { type: DELETING_INFO_ITEM };
}

export function deletingInfoItemSuccess(deletedInfoItem) {
    return { type: DELETING_INFO_ITEM_SUCCESS, deletedInfoItem };
}

export function deletingInfoItemFailure(error) {
    return { type: DELETING_INFO_ITEM_FAILURE, error };
}

export function resetDeletingInfoItem() {
    return { type: RESET_DELETING_INFO_ITEM };
}

export function addingLink() {
    return { type: ADDING_LINK };
}

export function addingLinkSuccess(newLink) {
    return { type: ADDING_LINK_SUCCESS, newLink };
}

export function addingLinkFailure(error) {
    return { type: ADDING_LINK_FAILURE, error };
}

export function resetAddingLink() {
    return { type: RESET_ADDING_LINK };
}

export function gettingLink() {
    return { type: GETTING_LINK };
}

export function gettingLinkSuccess(link) {
    return { type: GETTING_LINK_SUCCESS, link };
}

export function gettingLinkFailure(error) {
    return { type: GETTING_LINK_FAILURE, error };
}

export function resetGettingLink() {
    return { type: RESET_GETTING_LINK };
}

export function gettingUrl() {
    return { type: GETTING_URL };
}

export function gettingUrlSuccess(link) {
    return { type: GETTING_URL_SUCCESS, link };
}

export function gettingUrlFailure(error) {
    return { type: GETTING_URL_FAILURE, error };
}

export function resetGettingUrl() {
    return { type: RESET_GETTING_URL };
}

export function deletingLink() {
    return { type: DELETING_LINK };
}

export function deletingLinkSuccess(linkId) {
    return { type: DELETING_LINK_SUCCESS, linkId };
}

export function deletingLinkFailure(error) {
    return { type: DELETING_LINK_FAILURE, error };
}

export function resetDeletingLink() {
    return { type: RESET_DELETING_LINK };
}

export function editingLink() {
    return { type: EDITING_LINK };
}

export function editingLinkSuccess(updatedLink) {
    return { type: EDITING_LINK_SUCCESS, updatedLink };
}

export function editingLinkFailure(error) {
    return { type: EDITING_LINK_FAILURE, error };
}

export function resetEditingLink() {
    return { type: RESET_EDITING_LINK };
}

export function sendingLinkHit() {
    return { type: SENDING_LINK_HIT };
}

export function sendingLinkHitSuccess() {
    return { type: SENDING_LINK_HIT_SUCCESS };
}

export function sendingLinkHitFailure(error) {
    return { type: SENDING_LINK_HIT_FAILURE, error };
}

export function resetSendingLinkHit() {
    return { type: RESET_SENDING_LINK_HIT };
}

export function deletingLinks() {
    return { type: DELETING_LINKS };
}

export function deletingLinksSuccess(links) {
    return { type: DELETING_LINKS_SUCCESS, links };
}

export function deletingLinksFailure(error) {
    return { type: DELETING_LINKS_FAILURE, error };
}

export function resetDeletingLinks() {
    return { type: RESET_DELETING_LINKS };
}

export function deletingDashboards() {
    return { type: DELETING_DASHBOARDS };
}

export function deletingDashboardsSuccess(dashboards) {
    return { type: DELETING_DASHBOARDS_SUCCESS, dashboards };
}

export function deletingDashboardsFailure(error) {
    return { type: DELETING_DASHBOARDS_FAILURE, error };
}

export function resetDeletingDashboards() {
    return { type: RESET_DELETING_DASHBOARDS };
}

export function gettingMyDashboards() {
    return { type: GETTING_MY_DASHBOARDS };
}

export function gettingMyDashboardsSuccess(dashboards) {
    return { type: GETTING_MY_DASHBOARDS_SUCCESS, dashboards };
}

export function gettingMyDashboardsFailure(error) {
    return { type: GETTING_MY_DASHBOARDS_FAILURE, error };
}

export function resetGettingMyDashboards() {
    return { type: RESET_GETTING_MY_DASHBOARDS };
}

export function uploadingDashboardPhoto() {
    return { type: UPLOADING_DASHBOARD_PHOTO };
}

export function uploadingDashboardPhotoSuccess(dashboard) {
    return { type: UPLOADING_DASHBOARD_PHOTO_SUCCESS, dashboard };
}

export function uploadingDashboardPhotoFailure(error) {
    return { type: UPLOADING_DASHBOARD_PHOTO_FAILURE, error };
}

export function resetUploadingDashboardPhoto() {
    return { type: RESET_UPLOADING_DASHBOARD_PHOTO };
}

export function deletingDashboardPhoto() {
    return { type: DELETING_DASHBOARD_PHOTO };
}

export function sendingDashboardHit() {
    return { type: SENDING_DASHBOARD_HIT}
}

export function sendingDashboardHitSuccess() {
    return { type: SENDING_DASHBOARD_HIT_SUCCESS }
}

export function sendingDashboardHitFailure() {
    return { type: SENDING_DASHBOARD_HIT_FAILURE }
}

export function deletingDashboardPhotoSuccess(dashboard) {
    return { type: DELETING_DASHBOARD_PHOTO_SUCCESS, dashboard };
}

export function deletingDashboardPhotoFailure(error) {
    return { type: DELETING_DASHBOARD_PHOTO_FAILURE, error };
}

export function resetDeletingDashboardPhoto() {
    return { type: RESET_DELETING_DASHBOARD_PHOTO };
}

export function triggeredBulkUpload(triggerUpload) {
    return { type: TRIGGERED_BULK_UPLOAD,  triggerUpload};
}
